import { Box, BoxProps } from '@mui/material'
import Link from '~/src/components/mui-wrappers/Link'
import { useEoValue } from '~/src/hooks/useEoState'
import routes from '~/src/router/enums/routes.enum'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import EoLinkProps from '~/src/types/EoLinkProps'

interface Props extends BoxProps {
  redirect?: boolean,
  LinkProps?: Partial<Omit<EoLinkProps, 'href' | 'shallow'>>,
}

const CurrentFirmLogo = ({ redirect = false, LinkProps,  ...otherProps }: Props) => {
  const firm = useEoValue(FIRM_SELECTOR)

  if (!firm) {
    return null
  }

  if (!redirect) {
    return (
      <Box
        component='img'
        src={firm?.assets.logo_fullsize || ''}
        alt={firm?.name || ''}
        {...otherProps}
      />
    )
  }

  return (
    <Box {...otherProps}>
      <Link href={routes.FIRM_HOME} {...LinkProps}>
        <img
          height='50px'
          src={firm?.assets.logo_fullsize || ''}
          alt={firm?.name || ''}
        />
      </Link>
    </Box>
  )
}

export default CurrentFirmLogo
